@if (initialLoad) {
  <div class="am-flex-column height-100-dhv">
    <application-switcher></application-switcher>
    <div id="main-wrapper" class="overflow-auto">
      <app-sidebar class="app-sidebar"></app-sidebar>
      <div class="page-wrapper">
        <div class="container-fluid" [class.mb-60]="user?.features?.chat_feature">
          <mobile-header-menu></mobile-header-menu>
          <counters-cards></counters-cards>
          <candidates-carousel></candidates-carousel>
          <router-outlet></router-outlet>
        </div>
        @if (user.isInternal) { <chat></chat> }
      </div>
    </div>
  </div>
}
